import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//App
import { SnackbarState } from "../../types";
import { apiErrorMessage } from "../../utility/lib/error";
import { EMPTY_GUID } from "../../utility/constants/constants";
import CampaignForm from "./CampaignForm";

//Common
import { Snackbar } from "../common/VFX-UI";
import { OrganizationCampaignDto } from "../../app/model/api/types/dto/organizationCampaignDto";
import { CampaignViewModel } from "../../viewModels/campaignViewModel";
import { CampaignContext } from "./CampaignContainer";
import { CampaignFormContainerProps } from "../../types/campaign";
import organizationApi from "../../app/model/api/organizationApi";
import { getOrganizationId, getOrganizationName } from "../../utility/helpers/claimHelper";

export const CampaignFormContainer: React.FC<CampaignFormContainerProps> = (
  props
) => {
  const { onClose, onShowSuccess } = props;
  const campaignContext = useContext(CampaignContext);
  const  organizationId = getOrganizationId();
  const organizationName = getOrganizationName();

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = campaignContext?.id
    ? "Campaign updated"
    : "New Campaign added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, OrganizationCampaignDto>({
      mutationFn: async (payload: OrganizationCampaignDto) => {
      const response = await organizationApi.saveOrganizationCampaign(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
    onError: () => console.log("error"),
    onSuccess: () => console.log("success"),
  });

  const handleOnSubmit = async (values: CampaignViewModel) => {
      const campaign: OrganizationCampaignDto = values.toDto();
    mutate(campaign);
    };


  const initialValues = campaignContext?.id
    ? new CampaignViewModel(
        campaignContext?.data?.id ?? null,
        campaignContext.data?.organizationId !== null &&
        campaignContext.data?.organizationId !== undefined ? [campaignContext.data?.organizationId] : null,
        campaignContext?.data?.name ?? null,
        campaignContext?.data?.organization ?? null,
        campaignContext?.data?.code ?? null,
        campaignContext?.data?.description ?? null,
        campaignContext?.data?.startDate ? campaignContext?.data?.startDate?.split('T')[0] : null,
        campaignContext?.data?.endDate ? campaignContext?.data?.endDate?.split('T')[0] : null,
        campaignContext?.data?.donationStartDate ? campaignContext?.data?.donationStartDate?.split('T')[0] : null,
        campaignContext?.data?.creditCardStartDate ? campaignContext.data.creditCardStartDate.split('T')[0] : null,
        campaignContext?.data?.creditCardEndDate ? campaignContext.data.creditCardEndDate.split('T')[0] : null,
        campaignContext?.data?.checkStartDate ? campaignContext.data.checkStartDate.split('T')[0] : null,
        campaignContext?.data?.checkEndDate ? campaignContext.data.checkEndDate.split('T')[0] : null,
        campaignContext?.data?.payrollDeductionStartDate ? campaignContext.data.payrollDeductionStartDate.split('T')[0] : null,
        campaignContext?.data?.payrollDeductionEndDate ? campaignContext.data.payrollDeductionEndDate.split('T')[0] : null,
        campaignContext?.data?.pledgeGoal ?? null,
        campaignContext?.data?.isActive ?? null,
      )
      : new CampaignViewModel(EMPTY_GUID, [organizationId], "", organizationName, "", "", "", null, null, null, null, null, null, null, null, null, true)

  return (
    <>
      <CampaignForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
